"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("@babel/polyfill");

var slugline = _interopRequireWildcard(require("@krad/slugline"));

var _manson = _interopRequireDefault(require("@krad/manson"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var HLSController =
/*#__PURE__*/
function () {
  function HLSController(config) {
    _classCallCheck(this, HLSController);

    _manson.default.trace('configuring HLSController');

    this.url = config.url;
    this.codecs = config.codecs;
    this.lastSegmentID = undefined;
    this.playlistRefreshed = this.playlistRefreshed.bind(this);
    this.fetchPlaylist = this.fetchPlaylist.bind(this);
    this.fetchCodecInfo = this.fetchCodecInfo.bind(this);

    this.segmentFetchedCallback = function () {};

    this.segmentDownloadProgress = this.segmentDownloadProgress.bind(this);
  }
  /**
   * configure - Configures the state of the player after initialization
   *
   * @return {Promise} Executes n number of promises serially to mutate the state of the controller
   */


  _createClass(HLSController, [{
    key: "configure",
    value: function () {
      var _configure = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var variant;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.playlist) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this.fetchPlaylist(this.url);

              case 3:
                if (!(this.playlist.objType === 'MasterPlaylist')) {
                  _context.next = 9;
                  break;
                }

                this.masterPlaylist = this.playlist;
                variant = this.masterPlaylist.completeVariants.sort(function (a, b) {
                  return a.bandwidth - b.bandwidth;
                })[0];

                if (!variant) {
                  _context.next = 9;
                  break;
                }

                _context.next = 9;
                return this.fetchPlaylist(variant.url);

              case 9:
                if (this.codecs) {
                  _context.next = 12;
                  break;
                }

                _context.next = 12;
                return this.fetchCodecInfo();

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function configure() {
        return _configure.apply(this, arguments);
      };
    }()
  }, {
    key: "fetchPlaylist",

    /**
     * fetchPlaylist - Fetch the playlist the controller is configured for
     *
     * @return {Promise<Playlist>} Returns a Playlist object from slugline when successful
     */
    value: function fetchPlaylist(url) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _manson.default.debug("fetching playlist ".concat(url));

        slugline.Playlist.fetch(url).then(function (playlist) {
          _this.playlist = playlist;
          resolve(playlist);
        }).catch(function (err) {
          reject(err);
        });
      });
    }
    /**
     * fetchCodecInfo - Fetches codec information from media associated with the playlist
     *
     * @return {Promise<Array<String>>} Returns an array of strings for all the codecs in the playlist
     */

  }, {
    key: "fetchCodecInfo",
    value: function fetchCodecInfo() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _manson.default.debug('fetching codec information');

        if (_this2.playlist === undefined) {
          reject('Playlist not present');
          return;
        }

        _this2.playlist.getCodecsInformation().then(function (codecs) {
          _this2.codecs = codecs;
          resolve(codecs);
        }).catch(function (err) {
          reject(err);
        });
      });
    }
    /**
     * get totalDuration - Total duration of all segments as reported by the playlist
     *
     * @return {Float}  A float representing the duration of the playlist in seconds
     */

  }, {
    key: "segmentDownloadProgress",

    /**
     * segmentDownloadProgress - Callback used by the fetch process to update the controller about download progress
     *
     * @param  {Object} progress Simple object with properties about how much has been downloaded and how much is left
     */
    value: function segmentDownloadProgress(progress) {
      _manson.default.trace(JSON.stringify(progress));

      this.downloadProgress = progress;
    }
    /**
     * get downloadProgress - How much progress has been made of the download
     *
     * @return {Float}  0.0 - 100.0
     */

  }, {
    key: "playlistRefreshed",

    /**
     * playlistRefreshed - Callback fired when the playlist is refresh
     */
    value: function playlistRefreshed() {
      var _this3 = this;

      _manson.default.trace('playlist refreshed');

      var segments = [];

      if (this.lastSegmentID) {
        segments = this.playlist.segments.filter(function (s) {
          return s.id > _this3.lastSegmentID;
        });
      }

      if (segments.length > 0) {
        this.fetch(segments);
      }
    }
    /**
     * start - Begins fetching segments in a playlist sequentially
     * If a playlist is of type LIVE or EVENT it will periodically refresh the playlist
     * and fetch all segments appended to it
     *
     * @return {Promise} A promise of the fetch routine
     */

  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var stats;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _manson.default.trace('beginning segments fetch loop...');

                if (this.playlist) {
                  _context2.next = 3;
                  break;
                }

                throw 'Player Misconfigured: Missing playlist';

              case 3:
                stats = {};
                this.playlist.segments.forEach(function (s) {
                  stats[s.uri] = 0;
                });
                this.downloadStats = stats;

                if (this.playlist.type === 'LIVE' || this.playlist.type === 'EVENT') {
                  this.playlist.startAutoRefresh(this.playlistRefreshed);
                }

                return _context2.abrupt("return", this.fetch(this.playlist.segments));

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      return function start() {
        return _start.apply(this, arguments);
      };
    }()
  }, {
    key: "fetch",
    value: function () {
      var _fetch = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3(segments) {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, segment, segmentData;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 3;
                _iterator = segments[Symbol.iterator]();

              case 5:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context3.next = 18;
                  break;
                }

                segment = _step.value;

                if (!(segment.id <= this.lastSegmentID)) {
                  _context3.next = 9;
                  break;
                }

                return _context3.abrupt("continue", 15);

              case 9:
                _manson.default.debug("fetching segment #".concat(segment.id));

                this.lastSegmentID = segment.id;
                _context3.next = 13;
                return segment.fetch(this.segmentDownloadProgress);

              case 13:
                segmentData = _context3.sent;
                this.segmentFetchedCallback(segmentData);

              case 15:
                _iteratorNormalCompletion = true;
                _context3.next = 5;
                break;

              case 18:
                _context3.next = 24;
                break;

              case 20:
                _context3.prev = 20;
                _context3.t0 = _context3["catch"](3);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 24:
                _context3.prev = 24;
                _context3.prev = 25;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 27:
                _context3.prev = 27;

                if (!_didIteratorError) {
                  _context3.next = 30;
                  break;
                }

                throw _iteratorError;

              case 30:
                return _context3.finish(27);

              case 31:
                return _context3.finish(24);

              case 32:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 20, 24, 32], [25,, 27, 31]]);
      }));

      return function fetch(_x) {
        return _fetch.apply(this, arguments);
      };
    }()
  }, {
    key: "codecs",
    set: function set(val) {
      if (val && val.constructor.name === 'String') {
        this._codecs = JSON.parse(val);
      } else {
        this._codecs = val;
      }

      if (this._codecs) {
        this.codecsString = slugline.MPEGParser.createCodecsString(this._codecs);
      }
    },
    get: function get() {
      return this._codecs;
    }
    /**
     * get segmentsType - Returns the segment types associated with the playlist
     *
     * @return {String}  'ts' for transport streams. 'fmp4' for fragmented mp4s
     */

  }, {
    key: "segmentsType",
    get: function get() {
      if (this.playlist) {
        return this.playlist.segmentsType;
      }

      return undefined;
    }
  }, {
    key: "totalDuration",
    get: function get() {
      if (this.playlist) {
        return this.playlist.totalDuration;
      }

      return undefined;
    }
  }, {
    key: "downloadProgress",
    get: function get() {
      if (this.playlist) {
        return this._downloadProgress;
      }

      return undefined;
    }
    /**
     * set downloadProgress - Setter used to calculate download progress
     */
    ,
    set: function set(val) {
      var _this4 = this;

      this.downloadStats[val.uri] = val.progress;
      var total = 0;
      var segmentMax = 100 / Object.keys(this.downloadStats).length;
      Object.keys(this.downloadStats).forEach(function (k) {
        var segmentProgress = segmentMax * (100 * (_this4.downloadStats[k] / 10000));
        total += segmentProgress;
      });
      this._downloadProgress = total.toFixed(2) * 1;

      if (this.onDownloadProgress) {
        this.onDownloadProgress(this._downloadProgress);
      }
    }
  }]);

  return HLSController;
}();

var _default = HLSController;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@krad/plainview/distribution/hls-controller.js
// module id = 446
// module chunks = 0